export default __webpack_public_path__ + "static/media/linkedin (1).7c449f82.svg";